import React from 'react'
import { createRoot } from 'react-dom/client'
import Router from './views/router'

const el = document.getElementById('calendar-app')

const root = createRoot(el)
root.render(<Router />)
